// EXTERNAL DEPENDENCIES
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

// HELPERS
import { useBusinessProfileReduxState } from '.'
import { updateEditPageErrorMessage } from '@/redux/features'

/**
 * Reset error message if given variable is valid
 */
export function useErrorResetting(isValid: boolean) {
  const dispatch = useDispatch()

  const {
    editedProfileData: { errorMessage },
  } = useBusinessProfileReduxState()

  useEffect(() => {
    if (isValid && errorMessage) {
      dispatch(updateEditPageErrorMessage(''))
    }
  }, [isValid, errorMessage, dispatch])
}
